import { types } from 'mobx-state-tree';
import Base64 from '../../encodings/Base64';
import Bits from '../../primitives/Bits';
var BitsType = types.custom({
    name: 'Bits',
    fromSnapshot: function (snapshot) {
        return new Bits(snapshot);
    },
    toSnapshot: function (value) {
        return value.toString();
    },
    isTargetType: function (value) {
        return value instanceof Bits;
    },
    getValidationMessage: function (snapshot) {
        if (snapshot === undefined || Base64.isValidBase64UrlString(snapshot)) {
            return ""; // OK
        }
        return snapshot + " doesn't look like a valid hex string";
    },
});
export default BitsType;
//# sourceMappingURL=BitsType.js.map